const indexItems = [
  { id: 1, title: '娱乐圈顶流动态追踪', count: '128篇', tag: '热门', updated: '今日更新' },
  { id: 2, title: '网红圈最新翻车合集', count: '96篇', tag: '新瓜', updated: '1小时前' },
  { id: 3, title: '综艺节目幕后黑料', count: '87篇', tag: '深扒', updated: '3小时前' },
  { id: 4, title: '明星婚恋内幕大揭秘', count: '74篇', tag: '热榜', updated: '5小时前' },
  { id: 5, title: '社会热点事件深度挖掘', count: '65篇', tag: '追踪', updated: '6小时前' },
  { id: 6, title: '主播圈税务风波全纪录', count: '58篇', tag: '热点', updated: '8小时前' },
  { id: 7, title: '影视剧组现场爆料', count: '52篇', tag: '独家', updated: '12小时前' },
  { id: 8, title: '品牌代言翻车事件', count: '47篇', tag: '吃瓜', updated: '1天前' },
  { id: 9, title: '海外明星黑料搬运', count: '41篇', tag: '外网', updated: '1天前' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          瓜田合集
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 border border-secondary-200/60 rounded-xl hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0 group-hover:bg-primary-200/80 transition-colors">
                <span className="text-sm font-bold">{item.id}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{item.count}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="text-accent-600">{item.updated}</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}